import { Database, Model } from '@nozbe/watermelondb';

import { ValidationOperation } from '../../../validation/validator';

export type LocationEntityTableName = 'locations';

export type PreparedLocationData = {
    record: Model;
    table: LocationEntityTableName;
    operation: ValidationOperation;
};

export const mapRecord = (
    record: Model,
    table: LocationEntityTableName,
    operation: ValidationOperation,
): PreparedLocationData => ({
    record,
    table,
    operation,
});

export const addPreparedDataBatch = async (
    preparedData: PreparedLocationData[],
    database: Database,
) => {
    await database.batch(...preparedData.map(({ record }) => record));
};
